/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/* eslint-disable import/no-unresolved, import/default */

import deviceModelFieldsetTemplate from './device-model-fieldset.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function DeviceModelDirective($compile, $templateCache, $translate, types) {
    var linker = function (scope, element) {
        var template = $templateCache.get(deviceModelFieldsetTemplate);
        element.html(template);
        scope.types = types;
        $compile(element.contents())(scope);
    }
    return {
        restrict: "E",
        link: linker,
        scope: {
            deviceModel: '=',
            isEdit: '=',
            theForm: '='
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/device-model/device-model.directive.js